import { useEffect, useState } from "react";

const MemberSearchDropdown = ({
  className,
  placeHolder,
  selectedRadio,
  optionData,
  OnChange,
  dataFetching,
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilterData] = useState([]);
  const [isDropDown, setIsDropDown] = useState();
  const isDisabled = selectedRadio !== placeHolder.toLowerCase(); // Disable select if it doesn't match the selected radio

  useEffect(() => {
    if (searchText?.length > 0) {
      const filter = optionData?.filter((item) =>
        item.name?.toUpperCase()?.includes(searchText?.toUpperCase()),
      );
      setFilterData(filter);
    } else {
      setIsDropDown(false);
      setFilterData(optionData);
      OnChange();
    }
  }, [optionData, dataFetching, placeHolder, searchText]);

  useEffect(() => {
    setIsDropDown(false);
  }, [selectedRadio]);

  const handleData = (e) => {
    const name = e?.split(",")[1];
    setIsDropDown(false);
    OnChange(e);
    setSearchText(name);
  };
  return (
    <>
      <div
        className={`flex  w-full flex-col rounded-[4px] bg-[#f5f5f5] ${className}`}
      >
        <div className="rounded bg-transparent px-2">
          <input
            disabled={isDisabled}
            value={searchText}
            placeholder={`${
              selectedRadio && selectedRadio === placeHolder.toLowerCase()
                ? `Search by ${selectedRadio} name`
                : ""
            }`}
            className={`h-[26px] w-full bg-transparent text-[14px] text-[#868686] focus:outline-none`}
            onChange={(e) => (
              setSearchText(e.target.value), setIsDropDown(true)
            )}
          />
        </div>
      </div>

      {isDropDown && searchText && searchText?.length > 0 && dataFetching ? (
        dataFetching === "fetched" ? (
          <div className="scrollbar-custom absolute z-[500] mt-[70px] max-h-[300px] w-fit min-w-[220px] cursor-pointer overflow-y-scroll rounded-md border-[1px] border-[#e3e3e3] bg-white p-1 shadow-lg drop-shadow-lg">
            {filteredData && filteredData?.length > 0 ? (
              filteredData?.map((item, idx) => (
                <div
                  key={item.id}
                  onClick={() => handleData(`${item.id},${item.name}`)}
                  className={`text-[#434343] hover:bg-[#99c8ff] ${
                    idx === filteredData?.length - 1
                      ? ""
                      : "border-b-[1px] border-[#cfcfcf]"
                  } `}
                >
                  {item.ucc ? `${item.ucc} - ` : ""}
                  {item.name}
                </div>
              ))
            ) : (
              <div className=" text-center text-[#434343]">No Data</div>
            )}
          </div>
        ) : dataFetching === "fetching" ? (
          <div className="scrollbar-custom absolute z-[500] mt-[70px] max-h-[300px] w-fit min-w-[220px] cursor-pointer overflow-y-scroll rounded-md border-[1px] border-[#c3c3c3] bg-[#e3e3e3] p-1 shadow-lg drop-shadow-lg">
            <div className="text-[#434343]">Loading data...</div>
          </div>
        ) : (
          <div className="scrollbar-custom absolute z-[500] mt-[70px] max-h-[300px] w-fit min-w-[220px] cursor-pointer overflow-y-scroll rounded-md border-[1px] border-[#c3c3c3] bg-[#e3e3e3] p-1 shadow-lg drop-shadow-lg">
            <div className="border-b-[1px] border-[#cfcfcf] text-[#434343]">
              No Data
            </div>
          </div>
        )
      ) : null}
    </>
  );
};

export default MemberSearchDropdown;
